export default __webpack_public_path__ + "static/media/spheres.92e44be9.wav";